import { PINNED_CONTAINER_ID } from './constants';

export const adjustZIndex = (index?: number | string) => {
  const pinnedContainerElem = document.getElementById(PINNED_CONTAINER_ID);

  if (pinnedContainerElem) {
    pinnedContainerElem.style.zIndex = Number.isInteger(index) ? String(index) : '';
  }
};
